// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1r-0";
export var spinnerContainer = "_1r-1";